import React, { useState } from "react";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";
import { handleSubmitService } from "../services/ConsultationFormService";
import ConsentCheckbox from "./consentCheckbox";
import Logo from "../assets/img/GlobalStudyLogo.svg";

import "./style.css";
import { SERVICE_LIST } from "../constants/services";
const subjects = [
  "Accounting and Finance",
  "Adult Nursing / Nursing",
  "Agriculture and Forestry",
  "Animal Science / Veterinary & Animal Studies",
  "Anthropology",
  "Archaeology",
  "Architecture / Architectural Studies / Built Environment / Urban Planning",
  "Art and Design (Fine Art, Graphic Design, 3D Design, Crafts, Textile, etc.)",
  "Biological Sciences / Biology / Biomedicine / Biomedical Science / Biotechnology",
  "Building / Construction / Civil Engineering / Structural Engineering",
  "Business and Management Studies / Business Administration / Management Studies",
  "Chemical Engineering",
  "Chemistry / Chemistry & Biochemistry",
  "Civil Engineering",
  "Classics and Ancient History / Classical Civilisation",
  "Communication, Media, Journalism, Film, Digital Media, Media Studies",
  "Computer Science / Information Technology / Software Engineering / Data Science",
  "Counselling / Psychology-related (undergrad Social Work / Support Studies)",
  "Criminology / Forensic Science / Criminology & Sociology",
  "Dance / Drama / Performing Arts / Theatre / Music / Music & Sound Engineering",
  "Dentistry / Dental Technology / Dental Health Sciences",
  "Design & Crafts / Product Design / Industrial Design / Interior Design",
  "Drama, Film & Cinematics / Film Making / Creative Writing / Literature & Creative Arts",
  "Economics / Econometrics / Finance / Financial Economics",
  "Education / Education Studies / Teacher Training (Undergrad level where offered)",
  "Electrical and Electronic Engineering / Electrical Engineering",
  "English Language & Literature / Languages / Linguistics / Modern Languages",
  "Environmental Sciences / Geography / Geology / Earth & Marine Sciences / Environmental Studies",
  "Fashion / Textile / Fashion Design & Technology",
  "Food Science / Nutrition / Food Technology / Food & Agricultural Studies",
  "General Engineering / Multidisciplinary Engineering",
  "Geography / Environmental / Earth Sciences / Geology",
  "Health and Social Care / Allied Health Sciences / Physiotherapy / Occupational Therapy / Public Health-related degrees",
  "History / History of Art / Cultural History / Archaeology & History",
  "Hospitality, Leisure, Tourism, Hotel & Event Management / Tourism Studies / Leisure Management",
  "Land and Property Management / Real Estate / Estate Management / Land Economy-type courses",
  "Law (LLB or equivalent) / Combined Law (e.g. Law & Business / Law & Computing)",
  "Linguistics / Languages / Translation & Interpreting / Modern Languages & European Studies",
  "Materials Science / Materials Technology / Metallurgy / Materials Engineering",
  "Marketing / Advertising / Business-related Arts",
  "Mathematics / Statistics / Mathematics & Computing / Pure & Applied Mathematics",
  "Mechanical Engineering / General or Aerospace / Automotive / Manufacturing Engineering",
  "Medicine (MBBS or equivalent) / Pre-clinical & Clinical Medicine / Clinical Sciences / Medical Sciences",
  "Music / Music Performance / Music Production & Sound Engineering",
  "Neuroscience / Neurobiology / Cognitive Science (when offered at undergrad level)",
  "Occupational Therapy / Physiotherapy / Allied Health Professions",
  "Pharmacology / Pharmacy / Toxicology / Pharmaceutical Sciences",
  "Physics / Physics & Astronomy / Astrophysics / Space Sciences",
  "Psychology / Social Work / Sociology / Social Policy / Community & Youth Work / Social Services",
  "Politics / International Relations / Political Science / Development Studies",
  "Real Estate / Land & Property Management / Land Economy-type courses",
  "Robotics / Mechatronics / Emerging Interdisciplinary Engineering",
  "Software Engineering / Computer Engineering / Data Science & AI / Cybersecurity (as specialisations under Computer Science)",
  "Sports Science / Sports & Exercise Science / Sport Management / Sports Studies",
  "TESOL / Applied Linguistics / Language Studies (where offered at UG level)",
  "Tourism, Travel & Hospitality / Tourism & Hospitality Management / Hotel Management",
  "Veterinary Medicine / Animal Sciences / Animal Welfare & Behaviour",
  "Youth Work / Community & Social Services / Social Policy & Welfare",
];
const levels = ["Undergraduate", "Postgraduate", "PhD"];
const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];
const SelectArrow = () => (
  <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-400">
    <svg
      className="h-4 w-4"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.24 4.38a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
        clipRule="evenodd"
      />
    </svg>
  </span>
);

const countryCodes = [
  { label: "AD", code: "+376", flag: "🇦🇩" },
  { label: "AE", code: "+971", flag: "🇦🇪" },
  { label: "AF", code: "+93", flag: "🇦🇫" },
  { label: "AG", code: "+1-268", flag: "🇦🇬" },
  { label: "AL", code: "+355", flag: "🇦🇱" },
  { label: "AM", code: "+374", flag: "🇦🇲" },
  { label: "AO", code: "+244", flag: "🇦🇴" },
  { label: "AR", code: "+54", flag: "🇦🇷" },
  { label: "AT", code: "+43", flag: "🇦🇹" },
  { label: "AU", code: "+61", flag: "🇦🇺" },
  { label: "AW", code: "+297", flag: "🇦🇼" },
  { label: "AZ", code: "+994", flag: "🇦🇿" },

  { label: "BA", code: "+387", flag: "🇧🇦" },
  { label: "BB", code: "+1-246", flag: "🇧🇧" },
  { label: "BD", code: "+880", flag: "🇧🇩" },
  { label: "BE", code: "+32", flag: "🇧🇪" },
  { label: "BF", code: "+226", flag: "🇧🇫" },
  { label: "BG", code: "+359", flag: "🇧🇬" },
  { label: "BH", code: "+973", flag: "🇧🇭" },
  { label: "BI", code: "+257", flag: "🇧🇮" },
  { label: "BJ", code: "+229", flag: "🇧🇯" },
  { label: "BN", code: "+673", flag: "🇧🇳" },
  { label: "BO", code: "+591", flag: "🇧🇴" },
  { label: "BR", code: "+55", flag: "🇧🇷" },
  { label: "BS", code: "+1-242", flag: "🇧🇸" },
  { label: "BT", code: "+975", flag: "🇧🇹" },
  { label: "BW", code: "+267", flag: "🇧🇼" },
  { label: "BY", code: "+375", flag: "🇧🇾" },
  { label: "BZ", code: "+501", flag: "🇧🇿" },

  { label: "CA", code: "+1", flag: "🇨🇦" },
  { label: "CD", code: "+243", flag: "🇨🇩" },
  { label: "CF", code: "+236", flag: "🇨🇫" },
  { label: "CG", code: "+242", flag: "🇨🇬" },
  { label: "CH", code: "+41", flag: "🇨🇭" },
  { label: "CL", code: "+56", flag: "🇨🇱" },
  { label: "CM", code: "+237", flag: "🇨🇲" },
  { label: "CN", code: "+86", flag: "🇨🇳" },
  { label: "CO", code: "+57", flag: "🇨🇴" },
  { label: "CR", code: "+506", flag: "🇨🇷" },
  { label: "CU", code: "+53", flag: "🇨🇺" },
  { label: "CV", code: "+238", flag: "🇨🇻" },
  { label: "CY", code: "+357", flag: "🇨🇾" },
  { label: "CZ", code: "+420", flag: "🇨🇿" },

  { label: "DE", code: "+49", flag: "🇩🇪" },
  { label: "DJ", code: "+253", flag: "🇩🇯" },
  { label: "DK", code: "+45", flag: "🇩🇰" },
  { label: "DM", code: "+1-767", flag: "🇩🇲" },
  { label: "DO", code: "+1-809", flag: "🇩🇴" },
  { label: "DO", code: "+1-829", flag: "🇩🇴" },
  { label: "DO", code: "+1-849", flag: "🇩🇴" },
  { label: "DZ", code: "+213", flag: "🇩🇿" },

  { label: "EC", code: "+593", flag: "🇪🇨" },
  { label: "EE", code: "+372", flag: "🇪🇪" },
  { label: "EG", code: "+20", flag: "🇪🇬" },
  { label: "ER", code: "+291", flag: "🇪🇷" },
  { label: "ES", code: "+34", flag: "🇪🇸" },
  { label: "ET", code: "+251", flag: "🇪🇹" },

  { label: "FI", code: "+358", flag: "🇫🇮" },
  { label: "FJ", code: "+679", flag: "🇫🇯" },
  { label: "FM", code: "+691", flag: "🇫🇲" },
  { label: "FR", code: "+33", flag: "🇫🇷" },

  { label: "GA", code: "+241", flag: "🇬🇦" },
  { label: "GB", code: "+44", flag: "🇬🇧" },
  { label: "GD", code: "+1-473", flag: "🇬🇩" },
  { label: "GE", code: "+995", flag: "🇬🇪" },
  { label: "GH", code: "+233", flag: "🇬🇭" },
  { label: "GM", code: "+220", flag: "🇬🇲" },
  { label: "GN", code: "+224", flag: "🇬🇳" },
  { label: "GQ", code: "+240", flag: "🇬🇶" },
  { label: "GR", code: "+30", flag: "🇬🇷" },
  { label: "GT", code: "+502", flag: "🇬🇹" },
  { label: "GW", code: "+245", flag: "🇬🇼" },
  { label: "GY", code: "+592", flag: "🇬🇾" },

  { label: "HK", code: "+852", flag: "🇭🇰" },
  { label: "HN", code: "+504", flag: "🇭🇳" },
  { label: "HR", code: "+385", flag: "🇭🇷" },
  { label: "HT", code: "+509", flag: "🇭🇹" },
  { label: "HU", code: "+36", flag: "🇭🇺" },

  { label: "ID", code: "+62", flag: "🇮🇩" },
  { label: "IE", code: "+353", flag: "🇮🇪" },
  { label: "IL", code: "+972", flag: "🇮🇱" },
  { label: "IN", code: "+91", flag: "🇮🇳" },
  { label: "IQ", code: "+964", flag: "🇮🇶" },
  { label: "IR", code: "+98", flag: "🇮🇷" },
  { label: "IS", code: "+354", flag: "🇮🇸" },
  { label: "IT", code: "+39", flag: "🇮🇹" },

  { label: "JP", code: "+81", flag: "🇯🇵" },
  { label: "JO", code: "+962", flag: "🇯🇴" },

  { label: "KE", code: "+254", flag: "🇰🇪" },
  { label: "KG", code: "+996", flag: "🇰🇬" },
  { label: "KH", code: "+855", flag: "🇰🇭" },
  { label: "KI", code: "+686", flag: "🇰🇮" },
  { label: "KM", code: "+269", flag: "🇰🇲" },
  { label: "KP", code: "+850", flag: "🇰🇵" },
  { label: "KR", code: "+82", flag: "🇰🇷" },
  { label: "KW", code: "+965", flag: "🇰🇼" },
  { label: "KZ", code: "+7", flag: "🇰🇿" },

  { label: "LA", code: "+856", flag: "🇱🇦" },
  { label: "LB", code: "+961", flag: "🇱🇧" },
  { label: "LK", code: "+94", flag: "🇱🇰" },
  { label: "LR", code: "+231", flag: "🇱🇷" },
  { label: "LS", code: "+266", flag: "🇱🇸" },
  { label: "LT", code: "+370", flag: "🇱🇹" },
  { label: "LU", code: "+352", flag: "🇱🇺" },
  { label: "LV", code: "+371", flag: "🇱🇻" },
  { label: "LY", code: "+218", flag: "🇱🇾" },

  { label: "MA", code: "+212", flag: "🇲🇦" },
  { label: "MC", code: "+377", flag: "🇲🇨" },
  { label: "MD", code: "+373", flag: "🇲🇩" },
  { label: "ME", code: "+382", flag: "🇲🇪" },
  { label: "MG", code: "+261", flag: "🇲🇬" },
  { label: "MH", code: "+692", flag: "🇲🇭" },
  { label: "MK", code: "+389", flag: "🇲🇰" },
  { label: "ML", code: "+223", flag: "🇲🇱" },
  { label: "MM", code: "+95", flag: "🇲🇲" },
  { label: "MN", code: "+976", flag: "🇲🇳" },
  { label: "MR", code: "+222", flag: "🇲🇷" },
  { label: "MT", code: "+356", flag: "🇲🇹" },
  { label: "MU", code: "+230", flag: "🇲🇺" },
  { label: "MV", code: "+960", flag: "🇲🇻" },
  { label: "MW", code: "+265", flag: "🇲🇼" },
  { label: "MX", code: "+52", flag: "🇲🇽" },
  { label: "MY", code: "+60", flag: "🇲🇾" },
  { label: "MZ", code: "+258", flag: "🇲🇿" },

  { label: "NA", code: "+264", flag: "🇳🇦" },
  { label: "NE", code: "+227", flag: "🇳🇪" },
  { label: "NG", code: "+234", flag: "🇳🇬" },
  { label: "NI", code: "+505", flag: "🇳🇮" },
  { label: "NL", code: "+31", flag: "🇳🇱" },
  { label: "NO", code: "+47", flag: "🇳🇴" },
  { label: "NP", code: "+977", flag: "🇳🇵" },
  { label: "NR", code: "+674", flag: "🇳🇷" },
  { label: "NZ", code: "+64", flag: "🇳🇿" },

  { label: "OM", code: "+968", flag: "🇴🇲" },

  { label: "PA", code: "+507", flag: "🇵🇦" },
  { label: "PE", code: "+51", flag: "🇵🇪" },
  { label: "PG", code: "+675", flag: "🇵🇬" },
  { label: "PH", code: "+63", flag: "🇵🇭" },
  { label: "PK", code: "+92", flag: "🇵🇰" },
  { label: "PL", code: "+48", flag: "🇵🇱" },
  { label: "PT", code: "+351", flag: "🇵🇹" },
  { label: "PY", code: "+595", flag: "🇵🇾" },

  { label: "QA", code: "+974", flag: "🇶🇦" },

  { label: "RO", code: "+40", flag: "🇷🇴" },
  { label: "RS", code: "+381", flag: "🇷🇸" },
  { label: "RU", code: "+7", flag: "🇷🇺" },
  { label: "RW", code: "+250", flag: "🇷🇼" },

  { label: "SA", code: "+966", flag: "🇸🇦" },
  { label: "SC", code: "+248", flag: "🇸🇨" },
  { label: "SD", code: "+249", flag: "🇸🇩" },
  { label: "SE", code: "+46", flag: "🇸🇪" },
  { label: "SG", code: "+65", flag: "🇸🇬" },
  { label: "SI", code: "+386", flag: "🇸🇮" },
  { label: "SK", code: "+421", flag: "🇸🇰" },
  { label: "SL", code: "+232", flag: "🇸🇱" },
  { label: "SM", code: "+378", flag: "🇸🇲" },
  { label: "SN", code: "+221", flag: "🇸🇳" },
  { label: "SO", code: "+252", flag: "🇸🇴" },
  { label: "SR", code: "+597", flag: "🇸🇷" },
  { label: "SS", code: "+211", flag: "🇸🇸" },
  { label: "ST", code: "+239", flag: "🇸🇹" },
  { label: "SV", code: "+503", flag: "🇸🇻" },
  { label: "SY", code: "+963", flag: "🇸🇾" },
  { label: "SZ", code: "+268", flag: "🇸🇿" },

  { label: "TD", code: "+235", flag: "🇹🇩" },
  { label: "TG", code: "+228", flag: "🇹🇬" },
  { label: "TH", code: "+66", flag: "🇹🇭" },
  { label: "TJ", code: "+992", flag: "🇹🇯" },
  { label: "TM", code: "+993", flag: "🇹🇲" },
  { label: "TN", code: "+216", flag: "🇹🇳" },
  { label: "TO", code: "+676", flag: "🇹🇴" },
  { label: "TR", code: "+90", flag: "🇹🇷" },
  { label: "TT", code: "+1-868", flag: "🇹🇹" },
  { label: "TV", code: "+688", flag: "🇹🇻" },
  { label: "TW", code: "+886", flag: "🇹🇼" },
  { label: "TZ", code: "+255", flag: "🇹🇿" },

  { label: "UA", code: "+380", flag: "🇺🇦" },
  { label: "UG", code: "+256", flag: "🇺🇬" },
  { label: "US", code: "+1", flag: "🇺🇸" },
  { label: "UY", code: "+598", flag: "🇺🇾" },
  { label: "UZ", code: "+998", flag: "🇺🇿" },

  { label: "VA", code: "+379", flag: "🇻🇦" },
  { label: "VE", code: "+58", flag: "🇻🇪" },
  { label: "VN", code: "+84", flag: "🇻🇳" },
  { label: "VU", code: "+678", flag: "🇻🇺" },

  { label: "WS", code: "+685", flag: "🇼🇸" },

  { label: "YE", code: "+967", flag: "🇾🇪" },

  { label: "ZA", code: "+27", flag: "🇿🇦" },
  { label: "ZM", code: "+260", flag: "🇿🇲" },
  { label: "ZW", code: "+263", flag: "🇿🇼" }
];

const studyDestinations = [
  "Select an option",
  "Australia",
  "Canada",
  "Dubai",
  "Ireland",
  "New Zealand",
  "United Kingdom",
  "United States",
];
const hearAboutsUs = [
  "Select an option",
  "Email",
  "Google",
  "Social Media",
  "School & College",
  "Global StudyIn Counsellor",
  "Flyer & Poster",
  "Website",
  "Family & Friends",
  "Partners",
  "Newspaper",
  "Billboard/Hoarding",
];
const uniqueStudyDestinations = Array.from(new Set(studyDestinations));
const uniqueHearAboutsUs = Array.from(new Set(hearAboutsUs));


export default function ConsultationForm({ enablePaymentRedirection }) {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm({ defaultValues: { countryCode: "+44" } });
  const preferredContact = watch("preferredContact");



  // Helper: determine if this is a premium service form (by checking URL parameter)
  // Free services have ID=1 or "free", Premium services have ID=2
  const isPremiumService = (data) => {
    if (typeof window !== 'undefined') {
      // Check if the path contains "free" (which indicates a free service)
      if (!enablePaymentRedirection) return false;

      const pathname = window.location.pathname;
      const filterServiceList = SERVICE_LIST.filter(service => service.route === pathname);
      const paymentInfo = filterServiceList[0]?.payment;
      if (!paymentInfo) return false;

      if (paymentInfo.levelBased) {
        if (!paymentInfo.links) return false;

        const filteredLink = paymentInfo.links.find(link => link.level === (data.level || ""));
        return filteredLink?.link || "https://square.link/u/owCjea7u";
      } else {
        return paymentInfo?.link || "https://square.link/u/owCjea7u";
      }
    }
    return false; // No ID parameter means free/no payment
  };

  const onSubmit = async (data) => {
    const params = {
      IsCompany: false,
      AssignedTo: "1190398",
      Name: data.fullName,
      Email: [{ Text: data.email, Type: "Work" }],
      Phone: [
        { Text: "(" + data.countryCode + ")" + data.phone, Type: "Mobile" },
      ],
      Country: data.country,
      // Date: data.date,
      Level: data.level,
      Subject: data.subject,
      studyDestination: data.studyDestination,
      hearAbout: data.hearAbout,
      Message: data.message,
      consentCommunication: data.consentCommunication,
      consentInstitution: data.consentInstitution,
    };
    setLoading(true);

    try {
      const res = await handleSubmitService(params);
      const paymentLink = isPremiumService(data);
      if (paymentLink) {
        Swal.fire({
          imageUrl: Logo,
          imageAlt: "Global StudyIn logo",
          imageHeight: 100,
          imageWidth: 280,
          title: "Submitted!",
          text: "Thank you for your interest in our premium service! We will redirect you to our payment page now.",
          showConfirmButton: false,
          allowOutsideClick: false,
          timer: 3000,
          timerProgressBar: true,
        }).then(() => {
          window.location.href = paymentLink;
        });
      } else {
        Swal.fire({
          imageUrl: Logo,
          imageAlt: "Global StudyIn logo",
          imageHeight: 100,
          imageWidth: 280,
          title: "Submitted!",
          text: "Your request has been received. Someone from our team will reach out to you!",
          showConfirmButton: true,
          confirmButtonColor: "#2563eb",
        });
      }
      reset();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Submission failed",
        text: "Something went wrong. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center  p-6 consultation-form">
      {loading && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          role="status"
          aria-live="polite"
        >
          <div className="bg-white rounded-lg p-6 flex flex-col items-center gap-4 shadow-lg">
            <div className="flex items-center gap-2">
              <svg
                className="animate-spin h-6 w-6 text-blue-600"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg>
              <span className="text-gray-700 font-medium">Sending your request...</span>
            </div>
          </div>
        </div>
      )}
      <div className="w-full  bg-white shadow-lg rounded-xl p-8  pt-0">
        <h2 className="consultation-form-header-text text-2xl font-semibold text-gray-800 mb-2">
          Book Your Free Consultation
        </h2>
        <p className="consultation-form-header-desc text-gray-500 mb-6">
          Fill out the form below and we'll get back to you within 24 hours with personalized guidance for your education journey.
        </p>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          {/* Full Name */}
          <div>
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              Full Name <span className="form-required">*</span>
            </label>
            <input
              {...register("fullName", { required: "Full name is required" })}
              className="consultation-form-label w-full border border-gray-300 rounded-md pl-4 pr-10 py-2 mt-1 focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your full name"
            />
            {errors.fullName && (
              <p className="consultation-form-input text-red-500 text-sm">
                {errors.fullName.message}
              </p>
            )}
          </div>

          {/* Preferred contact */}
          {/* <div>
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              Select your Preferred contact details
              <span className="form-required">*</span>
            </label>

            <div className="mt-2 flex flex-col md:flex-row md:gap-6 gap-2">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  value="Phone"
                  {...register("preferredContact", {
                    required: "Please select one option",
                  })}
                />
                Phone
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  value="Email"
                  {...register("preferredContact")}
                />
                Email
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  value="Both"
                  {...register("preferredContact")}
                />
                Both
              </label>
            </div>

            {errors.preferredContact && (
              <p className="consultation-form-input text-red-500 text-sm mt-1">
                {errors.preferredContact.message}
              </p>
            )}
          </div> */}

          {/* Email */}
          <div>
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              Email Address
              <span className="form-required">*</span>
            </label>
            <input
              type="email"
              {...register("email", {
                required: "Email is required",
              })}
              className="consultation-form-label w-full border border-gray-300 rounded-md pl-4 pr-10 py-2 mt-1 focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your email"
            />
            {errors.email && (
              <p className="consultation-form-input text-red-500 text-sm">
                {errors.email.message}
              </p>
            )}
          </div>

          {/* Phone */}
          <div>
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              Phone Number
              <span className="form-required">*</span>
            </label>

            <div className="flex gap-2 mt-1">
              {/* Country Code Dropdown */}
              <select
                {...register("countryCode")}
                className="p-2 border rounded country-select consultation-form-label"
                defaultValue="+44"
              >
                {countryCodes.map((item, idx) => (
                  <option key={idx} value={item.code}>
                    {item.flag} {item.label} {item.code}
                  </option>
                ))}
              </select>

              {/* Phone Input */}
              <div className="mobile-input">
                <input
                  type="tel"
                  {...register("phone", {
                    required: "Phone number is required",
                    pattern: {
                      value: /^[0-9]{10,14}$/,
                      message:
                        "Enter minimum 10 and maximum 14 digit phone number",
                    },
                  })}
                  className="consultation-form-label flex-1 border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter valid phone number"
                />
                {errors.phone && (
                  <p className="text-red-500 text-sm mt-1 consultation-form-input">
                    {errors.phone.message}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Nationality */}
          <div>
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              Nationality <span className="form-required">*</span>
            </label>

            <div className="relative">
              <select
                {...register("country", { required: "Nationality is required" })}
                className={`
      w-full border border-gray-300 rounded-md
      pl-4 pr-10 py-2 mt-1 appearance-none bg-white
      focus:ring-2 focus:ring-blue-500
      ${watch("country") ? "text-gray-900" : "text-gray-400"}
    `}
              >
                <option value="">Select your nationality</option>
                {countries.map((country, i) => (
                  <option key={i} value={country}>
                    {country}
                  </option>
                ))}
              </select>

              <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-400">
                <svg
                  className="h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.24 4.38a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
            </div>

            {errors.country && (
              <p className="text-red-500 text-sm">
                {errors.country.message}
              </p>
            )}
          </div>


          {/* Study Level */}
          <div>
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              Study Level <span className="form-required">*</span>
            </label>

            <div className="relative">
              <select
                {...register("level", { required: "Level is required" })}
                className={`
        w-full border border-gray-300 rounded-md
        pl-4 pr-10 py-2 mt-1 appearance-none bg-white
        focus:ring-2 focus:ring-blue-500
        ${watch("level") ? "text-gray-900" : "text-gray-400"}
      `}
              >
                <option value="">Select study level</option>
                {levels.map((level, i) => (
                  <option key={i} value={level}>
                    {level}
                  </option>
                ))}
              </select>

              <SelectArrow />
            </div>

            {errors.level && (
              <p className="text-red-500 text-sm">
                {errors.level.message}
              </p>
            )}
          </div>


          {/* Preffered Subject */}
          <div>
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              Preferred Subject <span className="form-required">*</span>
            </label>

            <div className="relative">
              <select
                {...register("subject", { required: "Preferred Subject is required" })}
                className={`
        w-full border border-gray-300 rounded-md
        pl-4 pr-10 py-2 mt-1 appearance-none bg-white
        focus:ring-2 focus:ring-blue-500
        ${watch("subject") ? "text-gray-900" : "text-gray-400"}
      `}
              >
                <option value="">Select Preferred Subject</option>
                {subjects.map((subject, i) => (
                  <option key={i} value={subject}>
                    {subject}
                  </option>
                ))}
              </select>

              <SelectArrow />
            </div>

            {errors.subject && (
              <p className="text-red-500 text-sm">
                {errors.subject.message}
              </p>
            )}
          </div>

          {/* Study Destination */}
          <div>
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              Study Destination <span className="form-required">*</span>
            </label>

            <div className="relative">
              <select
                {...register("studyDestination", {
                  required: "Study Destination is required",
                })}
                className={`
        w-full border border-gray-300 rounded-md
        pl-4 pr-10 py-2 mt-1 appearance-none bg-white
        focus:ring-2 focus:ring-blue-500
        ${watch("studyDestination") ? "text-gray-900" : "text-gray-400"}
      `}
              >
                <option value="">Select Study Destination</option>
                {uniqueStudyDestinations
                  .filter(
                    (s) =>
                      s &&
                      s !== "Select an option" &&
                      s !== "Select Study Destination"
                  )
                  .map((study, i) => (
                    <option key={i} value={study}>
                      {study}
                    </option>
                  ))}
              </select>

              <SelectArrow />
            </div>

            {errors.studyDestination && (
              <p className="text-red-500 text-sm">
                {errors.studyDestination.message}
              </p>
            )}
          </div>

          {/* Preferred Consultation Date */}
          {/* <div>
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              Preferred Consultation Date
              <span className="form-required">*</span>
            </label>
            <input
              type="date"
              min={new Date().toISOString().split("T")[0]}
              {...register("date", {
                required: "Please select a date",

                validate: (value) => {
                  // value format from <input type="date"> is yyyy-mm-dd
                  const [year, month, day] = value.split("-").map(Number);

                  // ✅ block year that is not exactly 4 digits
                  if (year.toString().length !== 4) {
                    return "Year must be exactly 4 digits";
                  }

                  const userDate = new Date(year, month - 1, day);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);

                  // ✅ invalid date check
                  if (
                    userDate.getFullYear() !== year ||
                    userDate.getMonth() !== month - 1 ||
                    userDate.getDate() !== day
                  ) {
                    return "Invalid date selected";
                  }

                  // ✅ past date block
                  if (userDate < today) {
                    return "Date must be today or in the future";
                  }

                  return true;
                },
              })}
              className="consultation-form-label w-full border border-gray-300 rounded-md p-2 mt-1 focus:ring-2 focus:ring-blue-500"
            />

            {errors.date && (
              <p className="text-red-500 text-sm consultation-form-input">
                {errors.date.message}
              </p>
            )}
          </div> */}
          {/* How did you hear about GlobalStudyIn? */}
          <div>
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              How did you hear about Global StudyIn?
              <span className="form-required">*</span>
            </label>

            <div className="relative">
              <select
                {...register("hearAbout", { required: "This field is required" })}
                className={`
        w-full border border-gray-300 rounded-md
        pl-4 pr-10 py-2 mt-1 appearance-none bg-white
        focus:ring-2 focus:ring-blue-500
        ${watch("hearAbout") ? "text-gray-900" : "text-gray-400"}
      `}
              >
                <option value="">Select an option</option>
                {uniqueHearAboutsUs
                  .filter((h) => h && h !== "Select an option")
                  .map((hear, i) => (
                    <option key={i} value={hear}>
                      {hear}
                    </option>
                  ))}
              </select>

              <SelectArrow />
            </div>

            {errors.hearAbout && (
              <p className="text-red-500 text-sm">
                {errors.hearAbout.message}
              </p>
            )}
          </div>

          {/* Message */}
          <div className="md:col-span-2">
            <label className="consultation-form-input block text-sm font-medium text-gray-700">
              Message
            </label>
            <textarea
              {...register("message")}
              rows="3"
              placeholder="Tell us about your study goals, preferred universities, or any specific questions you have..."
              className="consultation-form-label w-full border border-gray-300 rounded-md pl-4 pr-10 py-2 mt-1 focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Privacy Policy Notice */}
          <div className="md:col-span-2 consultation-form-input block text-sm font-medium text-gray-700">
            Global StudyIn uses the contact information you provide to help schedule
            your free counselling session. You may unsubscribe anytime. Please
            refer to our{" "}
            <a
              href="/privacy-policy"
              className="text-blue-600 underline hover:text-blue-800 transition-colors duration-200"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>{" "}
            for information on how to unsubscribe.
          </div>

          {/* Consent Checkbox 1 */}
          <div className="md:col-span-2">
            <ConsentCheckbox
              name="consentCommunication"
              register={register}
              required={true}
              label="I’m happy to receive communication and useful resources related to my study preferences and event interests from Global StudyIn, and I explicitly consent to Global StudyIn collecting, storing, and processing my personal data in accordance with applicable data protection laws (including GDPR) for the purpose of providing optimum student counselling services."
            />
            {errors.consentCommunication && (
              <p className="text-red-500 text-sm mt-1">
                {errors.consentCommunication.message}
              </p>
            )}
          </div>

          {/* Consent Checkbox 2 */}
          <div className="md:col-span-2">
            <ConsentCheckbox
              name="consentInstitution"
              register={register}
              required={true}
              label="I’m happy to receive messages from participating institutions related to my Global StudyIn service registration."
            />
            {errors.consentInstitution && (
              <p className="text-red-500 text-sm mt-1">
                {errors.consentInstitution.message}
              </p>
            )}
          </div>

          {/* Submit Button */}
          <div className="md:col-span-2">
            <button
              type="submit"
              disabled={loading}
              className={`consultation-form-button w-full bg-blue-700 text-white py-8 rounded-md hover:bg-blue-800 transition flex items-center justify-center gap-2 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {loading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-2 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  Sending...
                </>
              ) : (
                "Send Message & Book Consultation"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
